import React, { useState } from "react";

import jwtEncode from "jwt-encode";
import ReCAPTCHA from "react-google-recaptcha";
import { parsePhoneNumberFromString } from "libphonenumber-js";
import { ToastContainer, toast } from "react-toastify";
import backgroundimage from "../images/getintouchbackground.jpeg";
import WhatsAppChat from "./WhatsAppChat";

const ContactExport = () => {
  const [form, setForm] = useState({ countryCode: "+91", attachment: null, });
  const [emailError, setEmailError] = useState("");
  const [captchaValue, setCaptchaValue] = useState(null);
  const [loading, setLoading] = useState(false); // ✅ NEW: loading state
  // ✅ ADD THIS FUNCTION HERE
  const convertFileToBase64 = (file) => {
    return new Promise((resolve, reject) => {

      const reader = new FileReader();

      reader.readAsDataURL(file);

      reader.onload = () => {
        resolve(reader.result);
      };

      reader.onerror = (error) => {
        reject(error);
      };

    });
  };


  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const validatePhone = () => {
    const mobile = form.mobile || "";
    const expectedLength = phoneLengths[form.countryCode] || 10;

    // only digits check
    if (!/^[0-9]+$/.test(mobile)) {
      return "Only numbers are allowed";
    }

    // length check
    if (mobile.length !== expectedLength) {
      return `Mobile number must be ${expectedLength} digits`;
    }

    return null;
  };

  const validateEmail = () => {
    const email = form.email || "";

    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!regex.test(email)) {
      setEmailError("Enter a valid email address");
      return false;
    }

    return true;
  };

  const countryNames = {
    "+93": "Afghanistan",
    "+355": "Albania",
    "+213": "Algeria",
    "+376": "Andorra",
    "+244": "Angola",
    "+54": "Argentina",
    "+374": "Armenia",
    "+61": "Australia",
    "+43": "Austria",
    "+994": "Azerbaijan",
    "+973": "Bahrain",
    "+880": "Bangladesh",
    "+32": "Belgium",
    "+55": "Brazil",
    "+1": "USA/Canada",
    "+86": "China",
    "+20": "Egypt",
    "+33": "France",
    "+49": "Germany",
    "+91": "India",
    "+62": "Indonesia",
    "+98": "Iran",
    "+964": "Iraq",
    "+39": "Italy",
    "+81": "Japan",
    "+965": "Kuwait",
    "+60": "Malaysia",
    "+52": "Mexico",
    "+31": "Netherlands",
    "+64": "New Zealand",
    "+234": "Nigeria",
    "+47": "Norway",
    "+92": "Pakistan",
    "+63": "Philippines",
    "+48": "Poland",
    "+974": "Qatar",
    "+7": "Russia",
    "+966": "Saudi Arabia",
    "+65": "Singapore",
    "+27": "South Africa",
    "+82": "South Korea",
    "+34": "Spain",
    "+94": "Sri Lanka",
    "+46": "Sweden",
    "+41": "Switzerland",
    "+66": "Thailand",
    "+90": "Turkey",
    "+971": "UAE",
    "+44": "UK",
    "+84": "Vietnam",
  };

  const phoneLengths = {
    "+93": 9, // Afghanistan
    "+355": 9, // Albania
    "+213": 9, // Algeria
    "+376": 6, // Andorra
    "+244": 9, // Angola
    "+54": 10, // Argentina
    "+374": 8, // Armenia
    "+61": 9, // Australia
    "+43": 10, // Austria (varies)
    "+994": 9, // Azerbaijan
    "+973": 8, // Bahrain
    "+880": 10, // Bangladesh
    "+32": 9, // Belgium
    "+55": 11, // Brazil
    "+1": 10, // USA / Canada
    "+86": 11, // China
    "+20": 10, // Egypt
    "+33": 9, // France
    "+49": 10, // Germany (varies)
    "+91": 10, // India
    "+62": 10, // Indonesia (varies)
    "+98": 10, // Iran
    "+964": 10, // Iraq
    "+39": 10, // Italy
    "+81": 10, // Japan
    "+965": 8, // Kuwait
    "+60": 9, // Malaysia
    "+52": 10, // Mexico
    "+31": 9, // Netherlands
    "+64": 9, // New Zealand
    "+234": 10, // Nigeria
    "+47": 8, // Norway
    "+92": 10, // Pakistan
    "+63": 10, // Philippines
    "+48": 9, // Poland
    "+974": 8, // Qatar
    "+7": 10, // Russia
    "+966": 9, // Saudi Arabia
    "+65": 8, // Singapore
    "+27": 9, // South Africa
    "+82": 10, // South Korea
    "+34": 9, // Spain
    "+94": 9, // Sri Lanka
    "+46": 9, // Sweden
    "+41": 9, // Switzerland
    "+66": 9, // Thailand
    "+90": 10, // Turkey
    "+971": 9, // UAE
    "+44": 10, // UK (varies)
    "+84": 10, // Vietnam
  };

  // ✅ SEND JWT TOKEN TO BACKEND
  const sendViaBackend = async (templateParams) => {
    let attachmentData = null;

    // convert file to base64
    if (templateParams.attachment) {

      const base64File = await convertFileToBase64(
        templateParams.attachment
      );

      attachmentData = {
        fileName: templateParams.attachment.name,
        fileType: templateParams.attachment.type,
        fileData: base64File,
      };
    }

    const payload = {
      name: templateParams.name,
      email: templateParams.email,
      mobile: templateParams.countryCode + " " + templateParams.mobile,
      product: templateParams.product,
      countryWithCode: templateParams.countryWithCode,
      message: templateParams.message,
      // ✅ attachment inside token
      attachment: attachmentData,
      exp: Math.floor(Date.now() / 1000) + 10 * 60, // ✅ expires in 10 mins
    };

    // ✅ Sign JWT on frontend using shared secret
    const token = jwtEncode(payload, process.env.REACT_APP_JWT_SECRET);

    // ✅ Send token directly to /send-mail
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}/send-mail`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ token }),
      }
    );

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.message || "Failed to send email");
    }

    return data;
  };

  // ✅ UPDATED handleSubmit — async with Brevo (all validations unchanged)
  const handleSubmit = async (e) => {
    e.preventDefault();


    if (!/^[A-Za-z\s]{5,}$/.test(form.name)) {
      toast.error("Name must be at least 5 letters (A-Z only)");
      return;
    }

    const phoneError = validatePhone();
    if (phoneError) {
      toast.error(phoneError);
      return;
    }

    // EMAIL VALIDATION
    if (!validateEmail()) {
      toast.error("Invalid email address");
      return;
    }
    if (
      form.message &&
      form.message.trim().length > 0 &&
      form.message.trim().length < 10
    ) {
      toast.error("Message must be at least 10 characters");
      return;
    }
    // CAPTCHA VALIDATION
    if (!captchaValue) {
      toast.error("Please verify reCAPTCHA");
      return;
    }

    console.log("Valid number:", form.mobile);
    console.log("Valid email:", form.email);

    const templateParams = {
      name: form.name,
      mobile: form.mobile,
      countryCode: form.countryCode || "+91",

      // NEW → Country Name + Code together
      countryWithCode:
        countryNames[form.countryCode] +
        " (" +
        (form.countryCode || "+91") +
        ")",
      email: form.email,
      country: form.country,
      product: form.product,
      message: form.message,
      // ✅ ADD THIS
      attachment: form.attachment,
    };

    console.log("form data: ", templateParams);

    setLoading(true);

    try {
      await sendViaBackend(templateParams);

      toast.success("Enquiry Sent Successfully! ✅");

      setForm({
        name: "",
        email: "",
        mobile: "",
        product: "",
        message: "",
        attachment: null,
        countryCode: "+91",
      });

      setCaptchaValue(null);
    } catch (error) {
      console.error(error);
      toast.error("⚠️ Failed to send enquiry. Try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className="container">
        {/* LEFT */}
        <div className="left">
          <div className="left-content">
            <h5>GET IN TOUCH</h5>

            <h1>
              Delivering India's Finest <br />
              To <span className="gold-textleft">Global Markets</span>
            </h1>

            <p>
              We help you export Indian products globally with ease,
              transparency, and competitive pricing.
            </p>

            <div className="info">

              <div className="info-row">
                {/* <span className="icon">📧</span> */}
                <a href="mailto:giridhar@uniqueglobalexports.com" className="info-row">
                  <span className="icon">📧</span>
                </a>
                <span className="text">giridhar@uniqueglobalexports.com</span>
              </div>

              <div className="info-row">
                <a href="tel:+918497944251" className="info-row">
                  <span className="icon">📞</span>
                </a>
                <span className="text">+91 8497944251 (WhatsApp available)</span>
              </div>

              <div className="info-row">
                <span className="icon">📍</span>
                <span className="text">
                  1-8-294/4/A/1, Aadarsh Nagar, Metpally,
                  Jagityal,Telangana - 505325, India
                </span>
              </div>

            </div>
          </div>
        </div>

        {/* RIGHT */}
        <div
          className="right"
          style={{
            background: `
              linear-gradient(rgba(0,0,0,0.35), rgba(0,0,0,0.4)),
              url(${backgroundimage})`,
          }}
        >
          <div className="form-wrapper">
            <form onSubmit={handleSubmit} className="form">
              <h2 className="form-title">
                Request a <span className="gold-textright">Quote</span>
              </h2>
              <p className="subtext">
                Share your requirements and our team will provide a tailored
                export solution at the earliest.
              </p>

              <div className="grid">
                <input
                  name="name"
                  value={form.name || ""}
                  onChange={(e) => {
                    const value = e.target.value;

                    // allow only letters + space
                    if (/^[A-Za-z\s]*$/.test(value)) {
                      setForm((prev) => ({
                        ...prev,
                        name: value,
                      }));
                    }
                  }}
                  placeholder="Full Name"
                  autoComplete="off"
                  required
                  pattern="[A-Za-z\s]{5,}"
                  title="Name must be at least 5 letters (only A-Z allowed)"
                />
                <input
                  type="email"
                  name="email"
                  value={form.email || ""}
                  onChange={(e) => {
                    const value = e.target.value;
                    handleChange(e);

                    const regex =
                      /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[A-Za-z]{2,}$/;

                    if (!regex.test(value)) {
                      setEmailError("Invalid email format");
                    } else {
                      setEmailError("");
                    }
                  }}
                  placeholder="Email Address"
                  autoComplete="off"
                  required
                />

                {/* <div className="mobile-field"> */}
                <select
                  name="countryCode"
                  value={form.countryCode || "+91"}
                  onChange={handleChange}
                  required
                >
                  <option value="+93">Afghanistan (+93)</option>
                  <option value="+355">Albania (+355)</option>
                  <option value="+213">Algeria (+213)</option>
                  <option value="+376">Andorra (+376)</option>
                  <option value="+244">Angola (+244)</option>
                  <option value="+54">Argentina (+54)</option>
                  <option value="+374">Armenia (+374)</option>
                  <option value="+61">Australia (+61)</option>
                  <option value="+43">Austria (+43)</option>
                  <option value="+994">Azerbaijan (+994)</option>
                  <option value="+973">Bahrain (+973)</option>
                  <option value="+880">Bangladesh (+880)</option>
                  <option value="+32">Belgium (+32)</option>
                  <option value="+55">Brazil (+55)</option>
                  <option value="+1">Canada (+1)</option>
                  <option value="+86">China (+86)</option>
                  <option value="+20">Egypt (+20)</option>
                  <option value="+33">France (+33)</option>
                  <option value="+49">Germany (+49)</option>
                  <option value="+91">India (+91)</option>
                  <option value="+62">Indonesia (+62)</option>
                  <option value="+98">Iran (+98)</option>
                  <option value="+964">🇮🇶 Iraq (+964)</option>
                  <option value="+39">Italy (+39)</option>
                  <option value="+81">Japan (+81)</option>
                  <option value="+965">Kuwait (+965)</option>
                  <option value="+60">Malaysia (+60)</option>
                  <option value="+52">Mexico (+52)</option>
                  <option value="+31">Netherlands (+31)</option>
                  <option value="+64">New Zealand (+64)</option>
                  <option value="+234">Nigeria (+234)</option>
                  <option value="+47">Norway (+47)</option>
                  <option value="+92">Pakistan (+92)</option>
                  <option value="+63">Philippines (+63)</option>
                  <option value="+48">Poland (+48)</option>
                  <option value="+974">Qatar (+974)</option>
                  <option value="+7">Russia (+7)</option>
                  <option value="+966">Saudi Arabia (+966)</option>
                  <option value="+65">Singapore (+65)</option>
                  <option value="+27">South Africa (+27)</option>
                  <option value="+82">South Korea (+82)</option>
                  <option value="+34">Spain (+34)</option>
                  <option value="+94">Sri Lanka (+94)</option>
                  <option value="+46">Sweden (+46)</option>
                  <option value="+41">Switzerland (+41)</option>
                  <option value="+66">Thailand (+66)</option>
                  <option value="+90">Turkey (+90)</option>
                  <option value="+971">UAE (+971)</option>
                  <option value="+44">UK (+44)</option>
                  <option value="+1">USA (+1)</option>
                  <option value="+84">Vietnam (+84)</option>
                </select>

                <input
                  type="tel"
                  name="mobile"
                  value={form.mobile || ""}
                  maxLength={phoneLengths[form.countryCode] || 12}
                  inputMode="numeric"
                  pattern="[0-9]*"
                  autoComplete="off"
                  placeholder="Mobile Number"
                  onChange={(e) => {
                    const maxLength = phoneLengths[form.countryCode] || 12;

                    // keep only digits
                    let value = e.target.value.replace(/\D/g, "");

                    // trim if pasted longer value
                    if (value.length > maxLength) {
                      value = value.slice(0, maxLength);
                    }

                    setForm((prev) => ({
                      ...prev,
                      mobile: value,
                    }));
                  }}
                  required
                />
                {/* </div> */}
              </div>

              <select
                name="product"
                value={form.product || ""}
                onChange={handleChange}
                required
              >
                <option value="" disabled>
                  Select a category
                </option>
                <option value="Spices">Spices</option>
                <option value="Fruits">Fruits</option>
                <option value="Vegetables">Vegetables</option>
                <option value="Mixed">Mixed / Custom Order</option>
              </select>

              <textarea
                name="message"
                value={form.message || ""}
                placeholder="Describe your requirement..."
                autoComplete="off"
                rows="4"
                onChange={(e) => {
                  const value = e.target.value;

                  setForm((prev) => ({
                    ...prev,
                    message: value,
                  }));
                }}
              />
              {/* file attachment */}
              <div className="file-upload">
                <label className="file-label">Upload Requirement File</label>

                <input
                  type="file"
                  name="attachment"
                  onChange={(e) => {
                    const file = e.target.files[0];

                    if (!file) return;

                    // 10MB limit
                    const maxSize = 10 * 1024 * 1024;

                    if (file.size > maxSize) {
                      toast.error("File size must be less than 10MB");

                      // clear selected file
                      e.target.value = "";

                      setForm((prev) => ({
                        ...prev,
                        attachment: null,
                      }));

                      return;
                    }

                    setForm((prev) => ({
                      ...prev,
                      attachment: file,
                    }));
                  }}
                />

                {form.attachment && (
                  <p className="file-name">
                    Selected: {form.attachment.name}
                  </p>
                )}
              </div>

              {/* GOOGLE RECAPTCHA */}
              <div style={{ marginTop: "20px" }}>
                <ReCAPTCHA
                  sitekey="6LehdN0sAAAAAHdY93fbLsEREHQS2wKOa_6Qs5UT"
                  onChange={(value) => setCaptchaValue(value)}
                />
              </div>

              {/* ✅ UPDATED BUTTON — shows loading state */}
              <button
                type="submit"
                disabled={loading}
                style={{
                  opacity: loading ? 0.75 : 1,
                  cursor: loading ? "not-allowed" : "pointer",
                }}
              >
                {loading ? "Sending..." : "Send Enquiry"}
              </button>

            </form>
          </div>
        </div>
      </div>

      {/* CSS — unchanged from your original */}
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Playfair+Display:wght@500;600;700&family=Poppins:wght@300;400;500&display=swap');

        * {
          box-sizing: border-box;
          margin: 0;
          padding: 0;
        }

        body {
          font-family: 'Poppins', sans-serif;
        }

        .container {
          display: flex;
          min-height: 100vh;
        }

        /* LEFT - CLASSIC PANEL */
        .left {
          flex: 1;
          background: #f8f6f2;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 60px;
          margin-top:0px;
        }

        .left-content {
          max-width: 420px;
        }

        .left h5 {
          color: #428dd7;
          letter-spacing: 2px;
          font-size: 12px;
          font-weight: bold;
        }

        .left h1 {
          font-family: 'Playfair Display', serif;
          font-size: 38px;
          font-weight: 600;
          line-height: 1.25;
          color: #1f2937;
        }

        .gold-textleft {
          background: linear-gradient(90deg, #c09a1b, #bfa72c, #f4c66a);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
        }
        .gold-textright {
          background: linear-gradient(90deg, #fcda6b, #d9c55e, #f4c66a);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
        }

        .left p {
          color: #4b5563;
          font-size: 15px;
          line-height: 1.7;
          margin-bottom: 25px;
        }

        /* INFO */
        .info-row {
          display: flex;
          align-items: center;
          gap: 12px;
          margin-bottom: 15px;
          cursor: pointer;
          text-decoration: none;
        }
          .info-row {
  display: grid;
  grid-template-columns: 35px 1fr;
  gap: 12px;
  margin-left:5px;
  align-items: start;
}

.info-row a {
  text-decoration: none;
  color: inherit;
}

.info-row a:hover,
.info-row a:focus,
.info-row a:active {
  text-decoration: none;
}

.icon {
  font-size: 20px;
}

.text {
  line-height: 1.6;
}

        .icon {
          width: 34px;
          height: 34px;
          display: flex;
          align-items: center;
          justify-content: center;
          background: #e5e7eb;
          border-radius: 8px;
          cursor: pointer;
        }

        .text {
          color: #374151;
          font-size: 14px;
        }

        /* RIGHT IMAGE */
        .right {
          flex: 1;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 40px;
          background-size: cover;
          background-position: center;
        }

        /* FORM */
        .form {
          width: 100%;
          max-width: 460px;
          padding: 35px;
          border-radius: 14px;
          margin-top: 50px;
          background: rgba(172, 169, 169, 0.56);
          backdrop-filter: blur(12px);
          -webkit-backdrop-filter: blur(12px);
          border: 1px solid rgba(255, 255, 255, 0.3);
          box-shadow: 0 8px 30px rgba(0,0,0,0.1);
        }

        .form-title {
          font-family: 'Playfair Display', serif;
          font-size: 26px;
          font-weight: 600;
          color: #f6f6f8;
          margin-bottom: 8px;
          letter-spacing: 0.5px;
        }

        .subtext {
          font-size: 13.5px;
          color: #f0f2f5;
          margin-bottom: 20px;
          line-height: 1.6;
        }

        .grid {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 15px;
        }

        input, select, textarea {
          width: 100%;
          padding: 14px;
          margin-top: 12px;
          border-radius: 8px;
          border: 1px solid #e5e7eb;
          font-size: 14px;
          background: #fcfcfc;
          transition: 0.2s;
        }

        input:focus, textarea:focus, select:focus {
          border-color: #c7a35c;
          box-shadow: 0 0 0 2px rgba(199,163,92,0.15);
          background: #fff;
        }

        button {
          margin-top: 20px;
          width: 100%;
          padding: 15px;
          background: #1f2937;
          color: #fff;
          border-radius: 8px;
          border: none;
          font-size: 15px;
          cursor: pointer;
          transition: 0.3s;
        }

        button:hover:not(:disabled) {
          background: #c7a35c;
          color: #111;
        }
          .file-upload {
  margin-top: 15px;
}

.file-label {
  display: block;
  margin-bottom: 8px;
  color: white;
  font-size: 14px;
  font-weight: 500;

  /* Text Shadow */
  text-shadow: 0px 2px 6px rgba(0, 0, 0, 0.45);
}

.file-name {
  margin-top: 8px;
  font-size: 13px;
  color: #f5f5f5;
  word-break: break-word;
}

input[type="file"] {
  background: #fff;
  padding: 10px;
  border-radius: 8px;
  cursor: pointer;
}

        /* MOBILE */
        @media (max-width: 900px) {
          .container {
            flex-direction: column;
            padding-top: 80px;
          }

          .left {
            padding: 30px 15px;
            text-align: center;
          }

          .left-content {
            max-width: 100%;
          }

          .left h1 {
            font-size: 26px;
            line-height: 1.3;
          }

          .left p {
            font-size: 14px;
          }

          .info-row {
            justify-content: center;
            text-align: left;
             cursor: pointer;
          }

          .right {
            padding: 20px 10px;
          }

          .form {
            padding: 20px;
            max-width: 100%;
          }

          .form-title {
            font-size: 22px;
          }

          .subtext {
            font-size: 13px;
          }

          .grid {
            grid-template-columns: 1fr;
            gap: 10px;
          }

          input, select, textarea {
            padding: 12px;
            font-size: 13px;
          }

          button {
            padding: 13px;
            font-size: 14px;
          }
        }
      `}</style>
      <WhatsAppChat />
      <ToastContainer position="top-right" autoClose={4000} />
    </>
  );
};

export default ContactExport;
